import { render, staticRenderFns } from "./PausePopup.vue?vue&type=template&id=498ad152&scoped=true&"
import script from "./PausePopup.vue?vue&type=script&lang=ts&"
export * from "./PausePopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ad152",
  null
  
)

export default component.exports